<app-shared-business-metadata-v2 [metadata]="metadata" />

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isContractInfoEmpty(metadata) || !isContractInfoEmpty(originalMetadata)
  "
>
  <div cardTitle i18n>Informations contractuelles</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="metadata?.startDate || originalMetadata?.startDate"
      >
        <span class="card__label" i18n>Date de début</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.startDate | customDate) !==
                  (metadata.startDate | customDate),
            }"
            >{{ metadata.startDate | customDate }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              (originalMetadata.startDate | customDate) !==
                (metadata.startDate | customDate) &&
              (originalMetadata.startDate | customDate) !== null &&
              (originalMetadata.startDate | customDate) !== undefined
            "
            >{{ originalMetadata.startDate | customDate }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.contractDuration || originalMetadata?.contractDuration"
      >
        <span class="card__label" i18n>Durée du contrat</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.contractDuration !== metadata.contractDuration,
            }"
            >{{ metadata.contractDuration }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.contractDuration !== metadata.contractDuration &&
              originalMetadata.contractDuration !== null &&
              originalMetadata.contractDuration !== undefined
            "
            >{{ originalMetadata.contractDuration }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.paymentFrequency || originalMetadata?.paymentFrequency"
      >
        <span class="card__label" i18n>Mode de paiement</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getPaymentFrequencyLabel(originalMetadata.paymentFrequency) !==
                  getPaymentFrequencyLabel(metadata.paymentFrequency),
            }"
            >{{ getPaymentFrequencyLabel(metadata.paymentFrequency) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getPaymentFrequencyLabel(originalMetadata.paymentFrequency) !==
                getPaymentFrequencyLabel(metadata.paymentFrequency) &&
              getPaymentFrequencyLabel(originalMetadata.paymentFrequency) !==
                null &&
              getPaymentFrequencyLabel(originalMetadata.paymentFrequency) !==
                undefined
            "
            >{{
              getPaymentFrequencyLabel(originalMetadata.paymentFrequency)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.splitPaymentFee !== null &&
            metadata?.splitPaymentFee !== undefined) ||
          (originalMetadata?.splitPaymentFee !== null &&
            originalMetadata?.splitPaymentFee !== undefined)
        "
      >
        <span class="card__label" i18n
          >Supplément pour paiement fractionné en %</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.splitPaymentFee !== metadata.splitPaymentFee,
            }"
            >{{ metadata.splitPaymentFee }}%</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.splitPaymentFee !== metadata.splitPaymentFee &&
              originalMetadata.splitPaymentFee !== null &&
              originalMetadata.splitPaymentFee !== undefined
            "
            >{{ originalMetadata.splitPaymentFee }}%</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card class="flex-basis-100 mb-12">
  <div cardTitle i18n>Informations LPP</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="metadata?.retirementPlan || originalMetadata?.retirementPlan"
      >
        <span class="card__label" i18n>Plan de retraite</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBusinessRetirementPlanLabel(
                  originalMetadata.retirementPlan
                ) !== getBusinessRetirementPlanLabel(metadata.retirementPlan),
            }"
            >{{ getBusinessRetirementPlanLabel(metadata.retirementPlan) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBusinessRetirementPlanLabel(
                originalMetadata.retirementPlan
              ) !== getBusinessRetirementPlanLabel(metadata.retirementPlan) &&
              getBusinessRetirementPlanLabel(
                originalMetadata.retirementPlan
              ) !== null &&
              getBusinessRetirementPlanLabel(
                originalMetadata.retirementPlan
              ) !== undefined
            "
            >{{
              getBusinessRetirementPlanLabel(originalMetadata.retirementPlan)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.staff?.length || originalMetadata?.staff?.length"
      >
        <span class="card__label" i18n>Personnel assuré</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getStaffSummary(originalMetadata.staff) !==
                  getStaffSummary(metadata.staff),
            }"
            >{{ getStaffSummary(metadata.staff) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getStaffSummary(originalMetadata.staff) !==
                getStaffSummary(metadata.staff) &&
              getStaffSummary(originalMetadata.staff) !== null &&
              getStaffSummary(originalMetadata.staff) !== undefined
            "
            >{{ getStaffSummary(originalMetadata.staff) }}</span
          >
        </div>
      </div>
    </div>
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="
          (metadata?.hasInsurance !== null &&
            metadata?.hasInsurance !== undefined) ||
          (originalMetadata?.hasInsurance !== null &&
            originalMetadata?.hasInsurance !== undefined)
        "
      >
        <span class="card__label" i18n>Possède une assurance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata.hasInsurance) !==
                  getBooleanLabel(metadata.hasInsurance),
            }"
            >{{ getBooleanLabel(metadata.hasInsurance) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata.hasInsurance) !==
                getBooleanLabel(metadata.hasInsurance) &&
              getBooleanLabel(originalMetadata.hasInsurance) !== null &&
              getBooleanLabel(originalMetadata.hasInsurance) !== undefined
            "
            >{{ getBooleanLabel(originalMetadata.hasInsurance) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.currentInsurer || originalMetadata?.currentInsurer"
      >
        <span class="card__label" i18n>Assureur actuel</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.currentInsurer !== metadata.currentInsurer,
            }"
            >{{ metadata.currentInsurer }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.currentInsurer !== metadata.currentInsurer &&
              originalMetadata.currentInsurer !== null &&
              originalMetadata.currentInsurer !== undefined
            "
            >{{ originalMetadata.currentInsurer }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.hasClaimsLastFiveYears !== null &&
            metadata?.hasClaimsLastFiveYears !== undefined) ||
          (originalMetadata?.hasClaimsLastFiveYears !== null &&
            originalMetadata?.hasClaimsLastFiveYears !== undefined)
        "
      >
        <span class="card__label" i18n
          >A subi des sinistres ces 5 dernières années</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata.hasClaimsLastFiveYears) !==
                  getBooleanLabel(metadata.hasClaimsLastFiveYears),
            }"
            >{{ getBooleanLabel(metadata.hasClaimsLastFiveYears) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata.hasClaimsLastFiveYears) !==
                getBooleanLabel(metadata.hasClaimsLastFiveYears) &&
              getBooleanLabel(originalMetadata.hasClaimsLastFiveYears) !==
                null &&
              getBooleanLabel(originalMetadata.hasClaimsLastFiveYears) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata.hasClaimsLastFiveYears)
            }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isAdditionalInfoEmpty(metadata) || !isAdditionalInfoEmpty(originalMetadata)
  "
>
  <div cardTitle i18n>Informations supplémentaires</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div class="card__row" *ngIf="metadata?.plan || originalMetadata?.plan">
        <span class="card__label" i18n>Nombre de groupes d'assurés</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getCollaboratorLPPPlanLabel(originalMetadata.plan) !==
                  getCollaboratorLPPPlanLabel(metadata.plan),
            }"
            >{{ getCollaboratorLPPPlanLabel(metadata.plan) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getCollaboratorLPPPlanLabel(originalMetadata.plan) !==
                getCollaboratorLPPPlanLabel(metadata.plan) &&
              getCollaboratorLPPPlanLabel(originalMetadata.plan) !== null &&
              getCollaboratorLPPPlanLabel(originalMetadata.plan) !== undefined
            "
            >{{ getCollaboratorLPPPlanLabel(originalMetadata.plan) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.collaboratorsCount !== undefined ||
          originalMetadata?.collaboratorsCount !== undefined
        "
      >
        <span class="card__label" i18n>Nombre de collaborateurs</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.collaboratorsCount !==
                  metadata.collaboratorsCount,
            }"
            >{{ metadata.collaboratorsCount }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.collaboratorsCount !==
                metadata.collaboratorsCount &&
              originalMetadata.collaboratorsCount !== null &&
              originalMetadata.collaboratorsCount !== undefined
            "
            >{{ originalMetadata.collaboratorsCount }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.coordinationDeduction !== null &&
            metadata?.coordinationDeduction !== undefined) ||
          (originalMetadata?.coordinationDeduction !== null &&
            originalMetadata?.coordinationDeduction !== undefined)
        "
      >
        <span class="card__label" i18n>Déduction de coordination</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata.coordinationDeduction) !==
                  getBooleanLabel(metadata.coordinationDeduction),
            }"
            >{{ getBooleanLabel(metadata.coordinationDeduction) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata.coordinationDeduction) !==
                getBooleanLabel(metadata.coordinationDeduction) &&
              getBooleanLabel(originalMetadata.coordinationDeduction) !==
                null &&
              getBooleanLabel(originalMetadata.coordinationDeduction) !==
                undefined
            "
            >{{ getBooleanLabel(originalMetadata.coordinationDeduction) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.insuredSalary !== undefined ||
          originalMetadata?.insuredSalary !== undefined
        "
      >
        <span class="card__label" i18n>Salaire assuré</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.insuredSalary !== metadata.insuredSalary,
            }"
            >{{ metadata.insuredSalary }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.insuredSalary !== metadata.insuredSalary &&
              originalMetadata.insuredSalary !== null &&
              originalMetadata.insuredSalary !== undefined
            "
            >{{ originalMetadata.insuredSalary }} CHF</span
          >
        </div>
      </div>
    </div>
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="metadata?.retirementType || originalMetadata?.retirementType"
      >
        <span class="card__label" i18n
          >Si salaire AVS plafonné et coordonné, plafonnement épargne</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBusinessLPPTypeLabel(originalMetadata.retirementType) !==
                  getBusinessLPPTypeLabel(metadata.retirementType),
            }"
            >{{ getBusinessLPPTypeLabel(metadata.retirementType) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBusinessLPPTypeLabel(originalMetadata.retirementType) !==
                getBusinessLPPTypeLabel(metadata.retirementType) &&
              getBusinessLPPTypeLabel(originalMetadata.retirementType) !==
                null &&
              getBusinessLPPTypeLabel(originalMetadata.retirementType) !==
                undefined
            "
            >{{
              getBusinessLPPTypeLabel(originalMetadata.retirementType)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.otherAmount !== undefined ||
          originalMetadata?.otherAmount !== undefined
        "
      >
        <span class="card__label" i18n>Autre montant</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.otherAmount !== metadata.otherAmount,
            }"
            >{{ metadata.otherAmount }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.otherAmount !== metadata.otherAmount &&
              originalMetadata.otherAmount !== null &&
              originalMetadata.otherAmount !== undefined
            "
            >{{ originalMetadata.otherAmount }} CHF</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.partTimeIncluded !== null &&
            metadata?.partTimeIncluded !== undefined) ||
          (originalMetadata?.partTimeIncluded !== null &&
            originalMetadata?.partTimeIncluded !== undefined)
        "
      >
        <span class="card__label" i18n>Temps partiel inclus</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata.partTimeIncluded) !==
                  getBooleanLabel(metadata.partTimeIncluded),
            }"
            >{{ getBooleanLabel(metadata.partTimeIncluded) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata.partTimeIncluded) !==
                getBooleanLabel(metadata.partTimeIncluded) &&
              getBooleanLabel(originalMetadata.partTimeIncluded) !== null &&
              getBooleanLabel(originalMetadata.partTimeIncluded) !== undefined
            "
            >{{ getBooleanLabel(originalMetadata.partTimeIncluded) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.minimalSalaryInsured !== null &&
            metadata?.minimalSalaryInsured !== undefined) ||
          (originalMetadata?.minimalSalaryInsured !== null &&
            originalMetadata?.minimalSalaryInsured !== undefined)
        "
      >
        <span class="card__label" i18n>Salaire minimal assuré</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata.minimalSalaryInsured) !==
                  getBooleanLabel(metadata.minimalSalaryInsured),
            }"
            >{{ getBooleanLabel(metadata.minimalSalaryInsured) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata.minimalSalaryInsured) !==
                getBooleanLabel(metadata.minimalSalaryInsured) &&
              getBooleanLabel(originalMetadata.minimalSalaryInsured) !== null &&
              getBooleanLabel(originalMetadata.minimalSalaryInsured) !==
                undefined
            "
            >{{ getBooleanLabel(originalMetadata.minimalSalaryInsured) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.otherInsuredSalary !== undefined &&
            metadata?.minimalSalaryInsured === false) ||
          (originalMetadata?.otherInsuredSalary !== undefined &&
            originalMetadata?.minimalSalaryInsured === false)
        "
      >
        <span class="card__label" i18n>Si autre, montant</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.otherInsuredSalary !==
                  metadata.otherInsuredSalary,
            }"
            >{{ metadata.otherInsuredSalary }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.otherInsuredSalary !==
                metadata.otherInsuredSalary &&
              originalMetadata.otherInsuredSalary !== null &&
              originalMetadata.otherInsuredSalary !== undefined
            "
            >{{ originalMetadata.otherInsuredSalary }} CHF</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isContributionsEmpty(metadata?.contributions) ||
    !isContributionsEmpty(originalMetadata?.contributions)
  "
>
  <div cardTitle i18n>Tranches d'âge et taux de cotisations</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          metadata?.contributions?.eighteenToTwentyFour !== undefined ||
          originalMetadata?.contributions?.eighteenToTwentyFour !== undefined
        "
      >
        <span class="card__label" i18n>De 18 à 24 ans</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.contributions.eighteenToTwentyFour !==
                  metadata.contributions.eighteenToTwentyFour,
            }"
            >{{ metadata.contributions.eighteenToTwentyFour }}%</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.contributions.eighteenToTwentyFour !==
                metadata.contributions.eighteenToTwentyFour &&
              originalMetadata.contributions.eighteenToTwentyFour !== null &&
              originalMetadata.contributions.eighteenToTwentyFour !== undefined
            "
            >{{ originalMetadata.contributions.eighteenToTwentyFour }}%</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.contributions?.twentyFiveToThirtyFour !== undefined ||
          originalMetadata?.contributions?.twentyFiveToThirtyFour !== undefined
        "
      >
        <span class="card__label" i18n>De 25 à 34 ans</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.contributions.twentyFiveToThirtyFour !==
                  metadata.contributions.twentyFiveToThirtyFour,
            }"
            >{{ metadata.contributions.twentyFiveToThirtyFour }}%</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.contributions.twentyFiveToThirtyFour !==
                metadata.contributions.twentyFiveToThirtyFour &&
              originalMetadata.contributions.twentyFiveToThirtyFour !== null &&
              originalMetadata.contributions.twentyFiveToThirtyFour !==
                undefined
            "
            >{{ originalMetadata.contributions.twentyFiveToThirtyFour }}%</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.contributions?.thirtyFiveToFourtyFour !== undefined ||
          originalMetadata?.contributions?.thirtyFiveToFourtyFour !== undefined
        "
      >
        <span class="card__label" i18n>De 35 à 44 ans</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.contributions.thirtyFiveToFourtyFour !==
                  metadata.contributions.thirtyFiveToFourtyFour,
            }"
            >{{ metadata.contributions.thirtyFiveToFourtyFour }}%</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.contributions.thirtyFiveToFourtyFour !==
                metadata.contributions.thirtyFiveToFourtyFour &&
              originalMetadata.contributions.thirtyFiveToFourtyFour !== null &&
              originalMetadata.contributions.thirtyFiveToFourtyFour !==
                undefined
            "
            >{{ originalMetadata.contributions.thirtyFiveToFourtyFour }}%</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.contributions?.fourtyFiveToFiftyFour !== undefined ||
          originalMetadata?.contributions?.fourtyFiveToFiftyFour !== undefined
        "
      >
        <span class="card__label" i18n>De 45 à 54 ans</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.contributions.fourtyFiveToFiftyFour !==
                  metadata.contributions.fourtyFiveToFiftyFour,
            }"
            >{{ metadata.contributions.fourtyFiveToFiftyFour }}%</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.contributions.fourtyFiveToFiftyFour !==
                metadata.contributions.fourtyFiveToFiftyFour &&
              originalMetadata.contributions.fourtyFiveToFiftyFour !== null &&
              originalMetadata.contributions.fourtyFiveToFiftyFour !== undefined
            "
            >{{ originalMetadata.contributions.fourtyFiveToFiftyFour }}%</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.contributions?.fiftyFiveTosixtyFive !== undefined ||
          originalMetadata?.contributions?.fiftyFiveTosixtyFive !== undefined
        "
      >
        <span class="card__label" i18n>De 55 à 64/65 ans</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.contributions.fiftyFiveTosixtyFive !==
                  metadata.contributions.fiftyFiveTosixtyFive,
            }"
            >{{ metadata.contributions.fiftyFiveTosixtyFive }}%</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.contributions.fiftyFiveTosixtyFive !==
                metadata.contributions.fiftyFiveTosixtyFive &&
              originalMetadata.contributions.fiftyFiveTosixtyFive !== null &&
              originalMetadata.contributions.fiftyFiveTosixtyFive !== undefined
            "
            >{{ originalMetadata.contributions.fiftyFiveTosixtyFive }}%</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngFor="let member of metadata.staff; let i = index"
>
  <div cardTitle i18n>Personnel {{ i + 1 }}</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div class="card__row" *ngIf="member.firstName || member.lastName">
        <span class="card__label" i18n>Nom complet</span>
        <span *ngIf="member.collaboratorId">
          <a
            (click)="viewCollaborator(member.collaboratorId)"
            class="clickable text-decoration-underline"
            >{{ member.firstName }} {{ member.lastName }}</a
          >
        </span>
        <span class="card__value" *ngIf="!member.collaboratorId"
          >{{ member.firstName }} {{ member.lastName }}</span
        >
      </div>
      <div class="card__row" *ngIf="member.birthDate">
        <span class="card__label" i18n>Date de naissance</span>
        <span class="card__value">{{ member.birthDate }}</span>
      </div>
      <div class="card__row" *ngIf="member.gender">
        <span class="card__label" i18n>Sexe</span>
        <span class="card__value">{{ getSexEnumLabel(member.gender) }}</span>
      </div>
      <div class="card__row" *ngIf="member.avsNumber">
        <span class="card__label" i18n>Numéro AVS</span>
        <span class="card__value">{{ member.avsNumber }}</span>
      </div>
      <div class="card__row" *ngIf="member.salary !== undefined">
        <span class="card__label" i18n>Salaire</span>
        <span class="card__value">{{ member.salary }} CHF</span>
      </div>
      <div class="card__row" *ngIf="member.position">
        <span class="card__label" i18n>Poste</span>
        <span class="card__value">{{ member.position }}</span>
      </div>
    </div>
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="member.married !== null && member.married !== undefined"
      >
        <span class="card__label" i18n>Marié(e)</span>
        <span class="card__value">{{ getBooleanLabel(member.married) }}</span>
      </div>
      <div class="card__row" *ngIf="member.marriageDate && member.married">
        <span class="card__label" i18n>Date de mariage</span>
        <span class="card__value">{{ member.marriageDate }}</span>
      </div>
      <div class="card__row" *ngIf="member.activityRate">
        <span class="card__label" i18n>Taux d'activité</span>
        <span class="card__value">{{ member.activityRate }}</span>
      </div>
      <div class="card__row" *ngIf="member.activityStart">
        <span class="card__label" i18n>Début d'activité</span>
        <span class="card__value">{{ member.activityStart }}</span>
      </div>
      <div class="card__row" *ngIf="member.dues">
        <span class="card__label" i18n>Avoir LPP</span>
        <span class="card__value">{{ member.dues }}</span>
      </div>
      <div class="card__row" *ngIf="member.address">
        <span class="card__label" i18n>Adresse</span>
        <span class="card__value">{{ member.address }}</span>
      </div>
    </div>
  </div>
</app-card>
